import '@reach/menu-button/styles.css';

import { format } from 'date-fns';
import filesize from 'filesize';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';

import { JpegIcon, JpgIcon, PdfIcon, PngIcon } from '@/components/Icon';
import Text from '@/components/Text';
import { useBreakpoints } from '@/hooks';
import { truncateStr } from '@/utils';

const typeToIconMap = {
  jpg: JpgIcon,
  jpeg: JpegIcon,
  png: PngIcon,
  pdf: PdfIcon,
};

const DocumentItem = ({ document, children, onClick, ...props }) => {
  const breakpoint = useBreakpoints();
  const isMobile = ['small', 'medium'].includes(breakpoint);

  const InputIcon = typeToIconMap?.[document?.type] ?? typeToIconMap.pdf;
  return (
    <Flex
      sx={{
        cursor: 'pointer',
        backgroundColor: 'white',
        borderRadius: '6px',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'border',
        py: 5,
        pl: 6,
        pr: 6,
        width: ['100%', '100%', '100%'],
      }}
      {...props}
    >
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          mr: 6,
        }}
      >
        <InputIcon />
      </Flex>
      <Box onClick={onClick}>
        <Text
          color="darkGrey"
          fontSize="14px"
          fontWeight="600"
          lineHeight="24px"
          sx={{ whiteSpace: 'nowrap', overflow: 'hidden', mr: 4 }}
        >
          {isMobile && document.name.length > 30 ? truncateStr(document.name, 24) : truncateStr(document.name, 50)}
        </Text>
        <Text flexGrow="1" color="darkGrey" fontSize="12px" lineHeight="24px">
          {filesize(Number(document.size ?? 0), { separator: ',', round: 1 })} •{' '}
          {format(new Date(document.uploaddate), 'dd.MM.yyyy')}
        </Text>
      </Box>
      <Flex alignItems="center" justifyContent="center" ml="auto">
        {children}
      </Flex>
    </Flex>
  );
};

DocumentItem.propTypes = {
  document: PropTypes.shape({
    documentId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    uploaddate: PropTypes.string.isRequired,
  }).isRequired,

  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

DocumentItem.defaultProps = {
  onClick: undefined,
};

export default DocumentItem;
